import {
  AdCopyStatus,
  AdGroupStatus,
  ApiTokenStatus,
  InvoiceStatus,
  Status,
  UserStatus,
} from '../../__generated__/graphql'

export type StatusStyledStatus =
  | Status
  | AdGroupStatus
  | AdCopyStatus
  | UserStatus
  | ApiTokenStatus
  | InvoiceStatus
  | 'Paused'
  | 'Waiting'

export const resolveStatusStyledColor = (status: StatusStyledStatus): string => {
  switch (status) {
    case Status.Active:
    case AdGroupStatus.Active:
    case AdCopyStatus.Active:
    case UserStatus.Enabled:
    case ApiTokenStatus.Enabled:
    case InvoiceStatus.Paid:
      return 'success.main'

    case Status.Inactive:
    case AdGroupStatus.Inactive:
    case AdCopyStatus.Inactive:
    case UserStatus.Disabled:
    case ApiTokenStatus.Disabled:
      return 'warning.main'

    case Status.Archived:
    case AdGroupStatus.Archived:
    case AdCopyStatus.Archived:
      return 'text.secondary'

    case AdGroupStatus.Ended:
    case AdGroupStatus.NoBudgetLeft:
    case AdGroupStatus.StartSoon:
    case AdCopyStatus.Pending:
    case AdCopyStatus.PendingValidation:
    case AdCopyStatus.Processing:
    case InvoiceStatus.Pending:
    case 'Paused':
    case 'Waiting':
      return 'warning.main'

    case UserStatus.Deleted:
    case AdCopyStatus.Rejected:
    case AdCopyStatus.Error:
      return 'error.main'

    case InvoiceStatus.Validated:
      return 'info.main'

    default:
      throw new Error(`Missing status color mapping for status: ${status}`)
  }
}
